import { gtmTrack } from './google-tag-manager-helpers';

const buildDataAttributeBasedLoadedProperties = (): Record<string, string> => {
  const segmentDataAttr = 'data-segment-page-loaded-properties';
  const element = document.querySelector<HTMLElement>(`[${segmentDataAttr}]`);
  if (!element) {
    return {};
  }
  const values = element.getAttribute(segmentDataAttr)?.split(',');
  const pageLoadProperties: Record<string, string> = {};

  values?.forEach(e => {
    const [key, value] = e.split('|');

    pageLoadProperties[key] = value;
  });

  return pageLoadProperties;
};

type BuildAdClickPageLoadedPropertiesProps = {
  clickId: string;
  clickIdSource: string;
};

const buildAdClickPageLoadedProperties = (): BuildAdClickPageLoadedPropertiesProps => {
  const adPlatforms = [
    {
      name: 'Reddit',
      key: 'rdt_cid',
    },
    {
      name: 'TikTok',
      key: 'ttclid',
    },
    {
      name: 'Facebook',
      key: 'fbclid',
    },
  ];

  const properties: BuildAdClickPageLoadedPropertiesProps = {
    clickId: '',
    clickIdSource: '',
  };

  adPlatforms.forEach(adPlatform => {
    const paramKey = adPlatform.key;
    const urlParams = new URLSearchParams(window.location.search);
    const foundParamValue = urlParams.get(paramKey);
    if (foundParamValue) {
      properties.clickId = foundParamValue;
      properties.clickIdSource = paramKey;
    }
  });

  return properties;
};

export const trackAdClickWithGtm = (properties = buildAdClickPageLoadedProperties()): void => {
  const { clickId, clickIdSource } = properties;
  if (clickId && clickIdSource) {
    gtmTrack('adClickAttributes', properties);
  }
};

export const buildCustomPageLoadedProperties = (): Record<string, string> => {
  const adClickProperties = buildAdClickPageLoadedProperties();
  trackAdClickWithGtm(adClickProperties);

  return {
    ...buildDataAttributeBasedLoadedProperties(),
    ...adClickProperties,
  };
};
